import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useCreateMeeting(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `
        mutation createEvent($eventInput: EventInput!, $clientId: ID!) {
            createEvent(eventInput: $eventInput, clientId: $clientId) {
              event {
                id
                name
              }
            }
        }`;

    const resolver = (resp) => {
      return resp;
    };

    return { query, resolver };
  }, []);

  const [createMeetingMutation, { loading }] = useMutationWithToaster(
    mutationFactory,
    { onDone }
  );

  return {
    isCreating: loading,
    createMeeting: async (formData, clientId) => {
      return createMeetingMutation(
        {
          clientId: clientId,
          eventInput: {
            name: formData.name,
            meetingTypeId: formData.type.id,
            startDate: formData.startDate,
            endDate: formData.endDate,
            attendees: formData.attendees.map(({ id }) => {
              return id;
            }),
          },
        },
        {
          successMsg: `Successfully created meeting ${formData.name}`,
          defaultErrorMsg:
            "Failed to create event. Please retry or contact support for assistance.",
        }
      );
    },
  };
}

export default useCreateMeeting;
